import { Autocomplete } from "@mui/joy";
import SearchIcon from "@mui/icons-material/Search";
import API_SERVICE from "../../utils/apiService";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { CURRENT_LOCATION } from "../../utils/constants";
import { useDebounce } from "../../utils/customHooks";

function SearchBox(props) {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const mapCenter = useSelector((state) => state.map.mapCenter);

  /**
   * sets suggestionList based on query
   */
  useDebounce(async () => {
    if (query === "") {
      setSuggestions([]);
      return;
    }
    if (query) {
      const suggestionsResponse = await API_SERVICE.fetchSuggestions(
        query,
        mapCenter,
      );
      setSuggestions(suggestionsResponse);
    }
  }, [query, mapCenter]);

  const isTablet = useMediaQuery("(max-width:900px)");

  return (
    <div className="SearchBox">
      <Autocomplete
        freeSolo
        startDecorator={<SearchIcon />}
        disableClearable={isTablet ? true : false}
        endDecorator={props.endDecorator ? props.endDecorator : null}
        placeholder={props.placeholder}
        getOptionKey={(option) => option.value}
        options={
          suggestions.length === 0
            ? props.currentLocation
              ? [CURRENT_LOCATION]
              : []
            : suggestions
        }
        onChange={(event, value, reason) => {
          if (reason === "selectOption") {
            if (value === CURRENT_LOCATION) {
              setTimeout(() => setQuery(""), 0); // ensure re-render
              props.handleSelectOption(CURRENT_LOCATION);
              return;
            }
            const placeId = value["value"];
            setQuery("");
            props.handleSelectOption(placeId);
            return;
          }
        }}
        onInputChange={(event, value, reason) => {
          if (reason === "clear") {
            // when user clicks "X" on the AutoComplete bar
            setQuery("");
            return;
          }
          setQuery(value);
        }}
        value={query}
        sx={{ width: isTablet ? 250 : 400 }}
      />
    </div>
  );
}

export default SearchBox;